module.exports = __webpack_public_path__ + "static/media/PM66.b049713c.png";